import * as React from 'react';
import { useSelector } from 'react-redux';
import { Col, Grid, Row } from '@cian/ui-kit';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import { VIEWED_TIMEOUT } from '../../../../constants/viewedBlock';

import { Wrapper } from '../../../../components/Wrapper';
import { Section } from '../../../../components/Section';

import { trackOffersHistoryView } from '../../../../utils/teaser';

import { MarketPriceContainer } from '../../../MarketPriceContainer';
import { PageAside } from '../../../../components/PageAside';
import { ViewAllReportContainer } from '../../../ViewAllReportContainer';
import { EScrollingBlocks } from '../../../../constants/scrollingBlocks';
import { useScrollingRef } from '../../../Scrolling';
import { TabsContainer } from '../../../TabsContainer';
import { AboutHomeContainer } from '../../../AboutHomeContainer';
import { OfferHistoryContainer } from '../../../OfferHistory/Desktop';
import { ValuationContentContainer } from '../../../ValuationContentContainer';
import { EstimationChartContainer } from '../../../EstimationChartContainer';
import { EstimationDealTypeBannerContainer } from '../../../EstimationDealTypeBannerContainer';
import { selectDealType } from '../../../../selectors/page';
import { RateOurEstimationContainer } from '../../../RateOurEstimationContainer';
import { selectEstimationByDealType } from '../../../../selectors/estimation';
import { ErrorScreen } from '../../../../components/ErrorScreen';
import { MarketTrendsContainer } from '../../../MarketTrendsContainer';
import { InfrastructureContainerLoad } from '../../../InfrastructureMapContainer';
import { OnbordingContainer } from '../../../OnbordingContainer';
import { MyHomeListingContainer } from '../../../MyHomeListingContainer';
import { HeroBanner } from '../../../../components/MyHome/HeroBanner';
import { ManagementCompanyContainer } from '../../../ManagementCompanyContainer';
import { ServicesContainer } from '../../../ServicesContainer';
import { StatusList } from '../../../Status/containers/StatusList';
import { PrelandingContainer } from '../../../PrelandingContainer';
import { SubscribeWidgetContainer } from '../../../SubscribeWidget';

export function MyHomeDesktopPage() {
  const marketPriceRef = useScrollingRef(EScrollingBlocks.MarketPrice);
  const aboutHomeRef = useScrollingRef(EScrollingBlocks.AboutHome);
  const estimationChartRef = useScrollingRef(EScrollingBlocks.EstimationChart);
  const offersHistoryRef = useScrollingRef(EScrollingBlocks.OffersHistory);
  const marketTrendsRef = useScrollingRef(EScrollingBlocks.MarketTrends);
  const dealTypeTabsRef = useScrollingRef(EScrollingBlocks.DealTypeTabs);
  const infrastructureRef = useScrollingRef(EScrollingBlocks.Infrastructure);
  const managementCompanyRef = useScrollingRef(EScrollingBlocks.ManagementCompany);

  const dealType = useSelector(selectDealType);
  const estimation = useSelector(selectEstimationByDealType(dealType));

  if (estimation.isError) {
    return <ErrorScreen />;
  }

  return (
    <>
      <HeroBanner>
        <MyHomeListingContainer />
      </HeroBanner>
      <Wrapper>
        <ValuationContentContainer>
          <Grid>
            <Row>
              <Col xs={9}>
                <Section marginTop={60} marginBottom={32}>
                  <TabsContainer refWrapper={dealTypeTabsRef} />
                  <EstimationDealTypeBannerContainer />
                </Section>
                <Section marginBottom={32}>
                  <OnbordingContainer />
                </Section>
                <Section>
                  <MarketPriceContainer refWrapper={marketPriceRef} />
                  <RateOurEstimationContainer />
                </Section>
                <Section>
                  <EstimationChartContainer refWrapper={estimationChartRef} />
                </Section>
                <Section marginBottom={80}>
                  <MarketTrendsContainer refWrapper={marketTrendsRef} />
                </Section>
                <Section marginBottom={80}>
                  <ActionAfterViewObserver callbackDelay={VIEWED_TIMEOUT} callback={trackOffersHistoryView}>
                    <OfferHistoryContainer refWrapper={offersHistoryRef} />
                  </ActionAfterViewObserver>
                </Section>
                <Section marginBottom={80}>
                  <ManagementCompanyContainer refWrapper={managementCompanyRef} />
                </Section>
                <Section>
                  <AboutHomeContainer refWrapper={aboutHomeRef} />
                </Section>
                <Section>
                  <InfrastructureContainerLoad refWrapper={infrastructureRef} />
                </Section>
              </Col>
              <Col xs={3}>
                <PageAside>
                  <ViewAllReportContainer />
                  <ServicesContainer />
                </PageAside>
              </Col>
            </Row>
          </Grid>
        </ValuationContentContainer>
      </Wrapper>
      <PrelandingContainer />
      <StatusList />

      <SubscribeWidgetContainer />
    </>
  );
}
